<template>
  <div class="reschedule-activity">
    <ActivitySmall :activity="activity" :interactable="false" :hideTimestamp="true"></ActivitySmall>
    <div class="row mt-3">
      <div class="col">
        <div class="property-block event-date-group">
          <i class="far fa-calendar-alt"></i>
          <DateSelector class="form-control activity-date-input" v-model:date="dateInput"></DateSelector>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="property-block event-title">
          <i class="far fa-clock"></i>
          <TimeSelector class="form-control activity-time-input" v-model:date="timeInput"></TimeSelector>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" :id="'reschedule-activity-cancel-check_' + uuid"
                 :checked="cancel" @change="$emit('update:cancel', $event.target.checked)"/>
          <label class="form-check-label" :for="'reschedule-activity-cancel-check_' + uuid">Deze activiteit
            annuleren</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateFormatter from "@/mixins/DateFormatter";
import ActivitySmall from "@/components/Activities/ActivitySmall";
import DateSelector from "@/components/UI/DateSelector";
import TimeSelector from "@/components/UI/TimeSelector";

let uuid = 0;

export default {
  name: "RescheduleActivity",
  components: { TimeSelector, DateSelector, ActivitySmall },
  mixins: [ DateFormatter ],
  props: {
    plannedDate: Date,
    cancel: Boolean,
    activity: Object
  },
  emits: [ "update:plannedDate", "update:cancel" ],
  computed: {
    dateInput:
        {
          get()
          {
            return this.plannedDate;
          },
          set(date)
          {
            let plannedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate(), this.plannedDate.getHours(),
                this.plannedDate.getMinutes());
            this.$emit("update:plannedDate", plannedDate);
          }
        },
    timeInput:
        {
          get()
          {
            return this.plannedDate;
          },
          set(dateTime)
          {
            let plannedDateTime = new Date(this.plannedDate.getFullYear(), this.plannedDate.getMonth(),
                this.plannedDate.getDate(), dateTime.getHours(), dateTime.getMinutes());
            this.$emit("update:plannedDate", plannedDateTime);
          }
        }
  },
  methods: {},
  beforeCreate()
  {
    this.uuid = uuid.toString();
    uuid += 1;
  }
}
</script>

<style lang="scss" scoped>
.property-block
{
  background: white;
  padding: 5px 15px;
  border-radius: 5px;
  box-shadow: $default-shadow;

  font-weight: bold;

  min-height: 50px;

  display: flex;
  flex-direction: row;
  align-items: center;
}

.activity-date-input
{
  border: none;
}

.activity-time-input
{
  border: none;
}
</style>